module.exports = __webpack_public_path__ + "img/reducer_logo_path.78b371c7.svg";